import * as React from 'react'


interface IProps {
  anchor: string
  className: string
  onClick?: (anchor: string) => void
}

class AnchorForScroll extends React.Component<IProps> {

  public handleOnclick = () => {
    const { onClick, anchor } = this.props
    if (onClick) {
      onClick(anchor)
    }
  }

  public render() {
    const { className } = this.props
    return (
      <a className={className} onClick={this.handleOnclick}>
        {this.props.children}
      </a>
    )
  }
}

export default AnchorForScroll


// WEBPACK FOOTER //
// ./src/pages/TermsPage/anchorForScroll.tsx